import React from "react";

import {
    Card as CardUI,
    CardContent,
    CardHeader,
    CardTitle,
} from "@/ui/card";

export const Card = ({
    className,
    content,
    contentClassName,
    hasIcon,
    headerClassName,
    icon,
    onClick,
    otherHeaderData,
    style,
    title,
    titleClassName,
} : {
    className?: string,
    content: string | React.ReactNode,
    contentClassName?: string,
    hasIcon?: boolean,
    headerClassName?: string,
    icon?: React.ReactNode,
    onClick?: () => void,
    otherHeaderData?: React.ReactNode,
    style?: React.CSSProperties,
    title?: string | React.ReactNode,
    titleClassName?: string
}) => (
    <CardUI
        className={className || ""}
        style={style}
        onClick={onClick}
    >
        {hasIcon && <span className="absolute right-3 top-3 flex min-h-6 md:right-6 md:top-6">{icon}</span>}
        {title || otherHeaderData ? (
            <CardHeader className={headerClassName || ""}>
                {title || otherHeaderData ? (
                    <div className="flex h-fit flex-col gap-1">
                        {title && <CardTitle className={titleClassName}>{title}</CardTitle>}
                        {otherHeaderData}
                    </div>
                ) : null}
            </CardHeader>
        ) : null}
        <CardContent className={`${contentClassName || ""}`}>{content}</CardContent>
    </CardUI>
);
